import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project/ProjectAreaPage/constants';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import useStopeNoteQueries, { StopeNoteQueries } from './useStopeNoteQueries';

const StopeNotePageLazy = lazyWithSuspense(() => import('./StopeNotePage'));

const page: Page<constants.StopeNotePageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: context.functions.canViewTeam,
    teamId: params.projectId,
  }),
  component: withLicenceAndDisclaimer({
    Component: makePage<constants.StopeNotePageParams, StopeNoteQueries>({
      WrappedPage: StopeNotePageLazy,
      titleFn: ([, , pours]) => (pours.data?.length === 1
        ? (pours.data[0].reference || i18n._('Pour Note'))
        : i18n._('Stope Note')),
      parentPathTemplate: `/projects/${parentConstants.ROUTE_PARAM_IDENTIFIER}/overview/stopes/${constants.STOPE_PARAM_IDENTIFIER}`,
      parentTitleFn: ([, mineModel, pours]) => {
        const stopeId = pours.data?.[0]?.stopeIdentifier?.stopeId;
        const stopeData = mineModel.data?.reticulationData?.stopes;

        if (stopeId && !stopeData) return `Stope ${stopeId}`;

        const stope = stopeData && stopeData.find((currentStope) => currentStope.stopeId === stopeId);

        if (stope) return `Stope ${stope.stopeName}`;

        return i18n._('Stope');
      },
      pageDataHook: useStopeNoteQueries,
    }),
  }),
};

export default page;
